import {availableCustomButtons} from "./available-custom-buttons.js";
import PlaceholderFactory from "./email-text-placeholders/placeholder-factory.js";
import ButtonFactory from "./button-factory.js";

export default async function createButtons() {
	const buttons = {};
	const buttonClasses = [];
	for (const button of availableCustomButtons) {
		let ButtonClass;

		try {
			if (button.type === 'content') {
				ButtonClass = await loadButtonClass(button);
				if (!ButtonClass) {
					continue;
				}
			} else if (button.type === 'placeholder') {
				ButtonClass = PlaceholderFactory.createButton(button);
				buttonClasses.push(ButtonClass); // Uložíme třídu pro pozdější použití
			} else {
				console.warn(`Neznámý typ tlačítka: ${button.type}`);
				continue;
			}

			buttons[button.id] = ButtonFactory.createButton(ButtonClass);
		} catch (e) {
			console.error(`Chyba při vytváření tlačítka ${button.id}:`, e);
		}
	}

	return {
		buttons,
		buttonClasses,
	};
}

async function loadButtonClass(button) {
	try {
		const path = convertToKebabPath(button.id);
		const module = await import(/* @vite-ignore */ path); // ToDo: nahradit ignore mapou souborů ['button1' => import..., 'button2' => import...]
		return module.default;
	} catch (e) {
		console.error(`Třída ${button.id} nebyla nalezena`, e);
		return null;
	}
}

function convertToKebabPath(buttonId) {
	// Převede 'kurzInfo' na 'kurz-info'
	const kebabCase = buttonId.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();

	// Pokud ID obsahuje více částí (např. 'kurzInfo'), vezmeme první část pro složku
	const parts = kebabCase.split('-');
	const folder = parts[0];  // 'kurz'

	return `./${folder}/${kebabCase}.js`;  // './kurz/kurz-info.js'
}

